module.exports = __webpack_public_path__ + "static/liveviewscreen-9880cd544d8e60b3466a80731c96a035.jpg";